import { render, staticRenderFns } from "./ParallaxHeader.vue?vue&type=template&id=22dedd91&"
import script from "./ParallaxHeader.vue?vue&type=script&lang=js&"
export * from "./ParallaxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ParallaxHeader.vue"
export default component.exports